import React, { useState, useEffect } from 'react';
import Box from '@material-ui/core/Box';
import smileIcon from '../images/smileIcon.png';
import { useLoggedInStyle } from '../css/useLoggedInStyle';
import Loading from '../../components/loading/Loading';
import { CircularProgress } from '@material-ui/core';

function MyEirLoggedInModal({ title, name }) {
    const classes = useLoggedInStyle();
    const [isLoading, setIsLoading] = useState(true);

    return (
        <>
            <Box className={classes.boxx}>
                {/* <h1>{title}</h1> */}
                {/* <img src={smileIcon} alt='smileIcon' /> */}
                <div className={classes.innerBoxx}>
                    <h2 className={classes.greeting}>{'Hi ' + (name || 'there')}</h2>
                    <h3 className={classes.wereloading}>We are loading your account.</h3>
                    <div className={classes.loader}>
                        <CircularProgress
                            disableShrink
                            style={{
                                color: '#F5EBDA',
                                width: '34px',
                                height: '40px',
                                // marginRight: '5px',
                            }}
                        />
                    </div>
                </div>
            </Box>
        </>
    );
}

export default MyEirLoggedInModal;
